import { Mic, MicOff } from "lucide-react";

// Small corner badge for the "Hey Edgar" wake word: shows when the mic is on; one tap turns it on or off (no prompt on every app open).
export default function WakeMic({ active, onToggle }) {
  return (
    <button type="button" onClick={onToggle} data-testid="edgar-wake-mic" data-active={active ? "true" : "false"}
      aria-label={active ? "Edgar is listening for 'Hey Edgar'. Tap to stop" : "Tap to let Edgar listen for 'Hey Edgar'"}
      title={active ? "Listening for 'Hey Edgar' · tap to stop" : "Tap to listen for 'Hey Edgar'"}
      className={`pb-safe fixed bottom-3 left-3 z-40 flex h-9 items-center gap-1.5 rounded-full pl-2.5 pr-3 text-[11px] font-semibold shadow-md ring-1 transition-colors ${active ? "bg-slate-900 text-white ring-slate-900" : "bg-white/95 text-slate-600 ring-slate-200 hover:text-[#0053DA]"}`}>
      {active ? <span className="relative flex h-4 w-4 items-center justify-center"><span className="absolute h-4 w-4 animate-ping rounded-full bg-rose-500/40" /><Mic className="relative h-3.5 w-3.5 text-rose-400" /></span> : <MicOff className="h-3.5 w-3.5" />}
      {active ? "Mic on" : "Mic off"}
    </button>
  );
}
